import { render, staticRenderFns } from "./MembershipStatus.vue?vue&type=template&id=981a6b52&scoped=true&"
import script from "./MembershipStatus.vue?vue&type=script&lang=js&"
export * from "./MembershipStatus.vue?vue&type=script&lang=js&"
import style0 from "./MembershipStatus.vue?vue&type=style&index=0&id=981a6b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981a6b52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
